import axios from "axios";
import DecryptData from "../Components/Utils/Decrypt";
import logout from "../Components/Utils/Logout";

const SERVER_URL = window.WEB_APP_API_URL;

const auth_key = DecryptData('nEkOtReSuEdArT')||"";

const getAuthKey = () => {
  const userToken = auth_key;
  if (!userToken) {
    // toast.warning('please login again')
  }
  return userToken || "";
};

let token = getAuthKey() || "";
const axiosInstance = axios.create({
  baseURL: SERVER_URL,
  headers: {
    token: token,
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    // Check for specific response messages indicating token issues
    const { message, error } = response.data || {};
    // console.log("testingggggggg",response);
    // console.log("message",message);
    // console.log("error",error);
    
    if (message === "Token missing" || error === "Token is invalid") {
      logout();
      return Promise.reject(new Error("Token issue detected. User logged out."));
    }
    return Promise.resolve(response);
  },
  (error) => {
    console.log("Error in Test",error?.response);
    
    if (!error.response) {
      // Handle cases where the server doesn't respond (e.g., network issues)
      return Promise.reject(new Error("Network error or no response from server."));
    }

    const { status,data } = error.response;

    if (status === 401) {
      // Handle unauthorized access
      logout();
      return Promise.reject(new Error("Unauthorized access. User logged out."));
    }

    if(data?.error === "Token missing" || data?.error === "Token is invalid"||data?.message === "Token missing" || data?.message === "Token is invalid" || data?.msg === "Token missing" || data?.msg === "Token is invalid"){
      logout();
      return Promise.reject(new Error("Unauthorized access. User logged out."));
    }

    // Propagate other errors
    return Promise.reject(error);
  }
);

export default axiosInstance;
